import { render, staticRenderFns } from "./ds-table.vue?vue&type=template&id=d2c657fa&scoped=true&"
import script from "./ds-table.vue?vue&type=script&lang=ts&"
export * from "./ds-table.vue?vue&type=script&lang=ts&"
import style0 from "./ds-table.vue?vue&type=style&index=0&id=d2c657fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c657fa",
  null
  
)

export default component.exports